import RCAUserWithAvatar from "../RCAUserWithAvatar";
import { useStyles } from "./RCACommentItem.styles";
import { IRCACommentItem } from "./RCACommentItemInterfaces";
import useDateFormat from "hooks/useDateFormat";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

const RCACommentItem = ({ comment, currentUserId, onEdit, onDelete }: IRCACommentItem) => {
    const classes = useStyles();
    const { formatDate } = useDateFormat();
    const { t } = useTranslation();
    const isOwner = currentUserId !== undefined && comment.user_id === currentUserId;

    return (
        <section className={classes.commentSection}>
            <div className={classes.avatarWrapper}>
                <RCAUserWithAvatar
                    imageUrl={comment.user?.media?.media_url}
                    name={`${comment.user?.first_name} ${comment.user?.last_name}`}
                    isObservation
                    hideText
                />
                <div className={classes.nameAndDateWrapper}>
                    <span className={classes.avatarName}>{`${comment.user.first_name} ${comment.user.last_name}`}</span>
                    <div className={classes.dateWrapper}>
                        <span className={classes.avatarDate}>{formatDate(comment.created_at, true)}</span>
                        {comment.updated_at && (
                            <span className={classes.editedBadge}>
                                {t("rca.action_plans.action_plan_details.comments.edited")}
                            </span>
                        )}
                    </div>
                </div>
                {isOwner && (onEdit || onDelete) && (
                    <div className={classes.editIconWrapper}>
                        {onEdit && (
                            <IconButton size="small" onClick={() => onEdit(comment)} className={classes.editIconButton}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                        )}
                        {onDelete && (
                            <IconButton
                                size="small"
                                onClick={() => onDelete(comment)}
                                className={classes.editIconButton}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        )}
                    </div>
                )}
            </div>
            <span className={classes.commentText}>{comment.description}</span>
        </section>
    );
};

export default RCACommentItem;
